
        var result = require("!!../../../../../../../node_modules/css-loader/dist/cjs.js!./Diagram.dark.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    